import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Structured Data component using JSON-LD format
 * Helps search engines understand the content type and context
 */
export const StructuredData = ({ type = 'WebPage', data }) => {
  // Base organization data
  const organizationData = {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    "name": "Savi Investing Private Limited",
    "alternateName": "SAVI Investing",
    "url": "https://saviinvesting.in",
    "description": "Value investing firm practicing disciplined, value-driven investing in Indian capital markets",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Room 117, Gagananchal Shopping Complex, 37 Dr. Abani Dutta Road",
      "addressLocality": "Howrah",
      "addressRegion": "West Bengal",
      "postalCode": "711106",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-8240845206",
      "contactType": "customer service",
      "email": "saviinvesting@gmail.com"
    },
    "sameAs": []
  };

  let structuredData;

  switch (type) {
    case 'Organization':
      structuredData = organizationData;
      break;
    
    case 'WebPage':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        ...data,
        "publisher": organizationData
      };
      break;
    
    case 'AboutPage':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        ...data,
        "mainEntity": organizationData
      };
      break;
    
    case 'ContactPage':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        ...data,
        "mainEntity": organizationData
      };
      break;

    case 'Article':
      structuredData = {
        "@context": "https://schema.org",
        "@type": "Article",
        ...data,
        "publisher": organizationData
      };
      break;
    
    default:
      structuredData = data;
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};
